import i18n from "../i18n/i18n";
import { TranslateKey } from "../i18n/i18n.types";

const wordForNumber = (count: string): string =>
  i18n.t(`common.count_numbers.${count}` as TranslateKey);

export const countInWords = (count?: number) => {
  if (!count) return undefined;

  return wordForNumber(count.toString()) || count;
};
